import { SurveyPageType } from '@employ-engage/data';

export const useSurveyResponseUtils = () => {
  const calculateQuestionNumber = (
    pageIndex: number,
    questionIndex: number,
    templatePages: SurveyPageType[]
  ) => {
    let questionNumber = 1;
    for (let i = 0; i < pageIndex; i++) {
      questionNumber += templatePages[i].questions.length;
    }
    questionNumber += questionIndex;
    return questionNumber;
  };

  const generateSmsTextMessage = (
    page: SurveyPageType,
    templatePages: SurveyPageType[],
    pageIndex: number,
    newPages: any
  ) => {
    return page.questions
      .map((question, questionIndex) => {
        return `
${calculateQuestionNumber(pageIndex, questionIndex, templatePages)}. ${
          question.question
        }
${
  question.type === 'select one'
    ? question.options
        ?.map((option) => {
          if (newPages[pageIndex].answers[questionIndex] === option.id) {
            return option.label.trimStart();
          }
          return null;
        })
        .filter((option) => !!option)
        .join('')
    : question.type === 'select many'
    ? !!question?.options &&
      question.options
        .map((option) => {
          if (
            newPages[pageIndex].answers[questionIndex].subAnswers
              ?.map((subAnswer: { id: any }) => subAnswer.id)
              ?.includes(option.id)
          ) {
            return option.label;
          }
          return null;
        })
        .filter((option) => !!option)
        .join('\n')
    : question.type === 'long text'
    ? newPages[pageIndex].answers[questionIndex]
    : question.type === 'short text'
    ? newPages[pageIndex].answers[questionIndex]
    : ''
}
`;
      })
      .join('')
      .trim();
  };

  // const sendEmailOfResponse = (
  //   survey: DocumentData,
  //   templatePages: any[],
  //   company:
  //     | Company
  //     | {
  //         id: string;
  //       },
  //   employeeId: string,
  //   responseId: string,
  //   newPages: any,
  //   recipient: FirestoreEmployee,
  //   missedSms = false,
  //   isSender = false
  // ) => {
  //   let html = `
  // <div>
  //   Hello,<br><br>
  //   ${
  //     missedSms
  //       ? `You missed a text message with the following response because you have not consented to receive SMS messages. To consent click <a href="${company.id}.${process.env['VITE_CORE_HOST_APP']}/sms-consent/${recipient.id}" target="_blank">here</a>.<br><br>`
  //       : isSender
  //       ? `Here is the response you submitted for ${survey.title}`
  //       : `A new response has been submitted for ${survey.title}.<br><br>`
  //   }
  // </div>
  //                         `;
  //   const promises: any[] = [];
  //   templatePages.forEach((page, index) => {
  //     promises.push(
  //       getDoc(
  //         getSurveyResponseDocRef(company.id, employeeId, responseId)
  //       ).then((docSnap) => {
  //         if (docSnap.exists()) {
  //           const response = docSnap.data() as SurveyResponse;
  //           if (response) {
  //             return ReactDOMServer.renderToStaticMarkup(
  //               <SurveyResponseEmail
  //                 currentPage={page}
  //                 templatePages={templatePages}
  //                 pageIndex={index}
  //                 newPages={newPages}
  //               />
  //             );
  //           } else {
  //             throw Error('Response does not exist');
  //           }
  //         }
  //       })
  //     );
  //   });

  //   Promise.all(promises).then((pageHtmls) => {
  //     pageHtmls.forEach((pageHtml, index) => {
  //       html += `
  //                             <div>
  //                               <h3>Page ${index + 1}</h3>
  //                               ${pageHtml}
  //                             </div>
  //                           `;
  //     });

  //     html += `
  //                           <div>
  //                             <br><br>
  //                             Thank you,<br>
  //                             The Employ Engage Team
  //                           </div>
  //                         `;

  //     const addResponseEmail = {
  //       to: `${recipient.firstName} ${recipient.lastName} <${recipient.emailAddress}>`,
  //       from: `Employ Engage <no-reply@employengage.com>`,
  //       message: {
  //         subject: survey.title,
  //         html,
  //       },
  //     };

  //     addDoc(getGeneralEmailCollectionRef(), addResponseEmail).then(() => {
  //       console.info('Email sent successfully');
  //     });
  //   });
  // };
  return {
    calculateQuestionNumber,
    generateSmsTextMessage,
    // sendEmailOfResponse,
  };
};
